import * as Sentry from '@sentry/react';
import setup from 'logrocket/setup';

import { env } from './env';

// lr.paidnice.com reverse-proxies LogRocket (logrocketProxy function) so
// recording survives adblock filter lists that block *.lr-in.com. sdkServer
// serves logger.min.js; ingestServer receives the /i and /s POSTs.
//
// sdkServer is only honoured by `logrocket/setup`, not by `LogRocket.init()`
// (init silently drops it and loads logger-1.min.js from cdn.lr-in.com), so
// every consumer must use this instance rather than the default export.
const PROXY = env.logrocketProxyOverride || `https://lr.paidnice.com`;

export const LogRocket = setup({
  sdkServer: PROXY,
  ingestServer: PROXY,
});

/** Replay URL of the current LogRocket session; undefined until LogRocket resolves it. */
export let logRocketSessionURL: string | undefined;

/**
 * Call after LogRocket.init. Links the replay to every Sentry event (tag) and
 * to every API request's server-side log lines (X-LogRocket-Session header,
 * see axiosBaseQuery and backend requestLog middleware).
 */
export function linkLogRocketSession() {
  LogRocket.getSessionURL(sessionURL => {
    logRocketSessionURL = sessionURL;
    Sentry.setTag(`logrocket`, sessionURL);
  });
}
